export enum AtlasEditorTab {
  GENERAL = 'general',
  THEME = 'theme',
  PRIVACY = 'privacy',
  LOCALE = 'locale',
}

export interface AtlasDisplay {
  id: string;
  name: string;
  description: string;
  preview: string;
  floorId: string;
  locationId: string;
  companyId: string;
  lastHeartbeatAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface AtlasConfig {
  defaultBearing?: number;
  timeoutSeconds?: number;
  zoom?: number;
  theme: string;
  maskMeetingTitles: boolean;
  hideMeetingAttendees: boolean;
  militaryTime: boolean;
  notice: string;
  showNotice: boolean;
  showPositionDot?: boolean;
  showCompanyLogo?: boolean;
  useLocationTheme: boolean;
  locationThemeOverride: string;
  allowDeskBooking: boolean;
  allowRoomBooking: boolean;
  showPii: boolean;
  showAppClip: boolean;
  showQuickActions: boolean;
  showTakeovers: boolean;
  showPositionControl?: boolean;
  lockViewToLocation: boolean;
  showGlobe: boolean;
  locale: 'fr' | 'en' | 'es' | 'ro';
  deviceId: string;
  locationId: string;
  floorId: string;
  companyId: string;
  viewOnly: boolean;
  localPosition?: { x: number; y: number };
  globalPosition?: [number, number];
  pallette: {
    50: string;
    100: string;
    200: string;
    300: string;
    400: string;
    500: string;
    600: string;
    700: string;
    800: string;
    900: string;
    950: string;
  };
}
